export default {
  gapBetweenStackedColumns: 0
}
